import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

@Component
export class MobileFiltersList extends ThemeComponent {
    @Prop id!: string;
    @Prop master!: boolean;
    @Prop({default: 'null'}) returnToId!: string;
    @Prop({default: 'null'}) returnToTitle!: string;
    @Prop({default: 'null'}) heading!: string;

    @Prop({ default: 'null'}) filter!: ShopifyFilter;
    @Ref() priceRangeSlider!: HTMLElement;
    @Ref() inputMin!: HTMLInputElement;
    @Ref() inputMax!: HTMLInputElement;

    @Ref({required: false}) mobileMenuListTrigger!: HTMLButtonElement[];

    init() {

        // Init child trigger click event listener
        if (this.mobileMenuListTrigger) {
            for (const trigger of this.mobileMenuListTrigger) {
                this.$listen(trigger, 'click', (event) => {
                    // Do not complete animation of sub-child if <a></a> was clicked
                    if (event.target) {
                        const clickedElement = event.target as HTMLElement;
                        if (clickedElement.tagName === 'A') {
                            return;
                        }
                    }
                    trigger.classList.toggle('is-active');

                    this.handleListTrigger(trigger);
                });
            }
        }

        this.initSlider();
    }

    handleListTrigger(element: HTMLButtonElement) {
        // Get ID of list to show
        const idToShow = element.getAttribute('data-target-list-id');

        // Get list
        const listToShow = document.getElementById(`${idToShow}`);
        if (!listToShow) {
            this.$log.error(`List with id: ${idToShow} could not be found`);
            return;
        }

        // Remove all active classes
        const activeLists = document.querySelectorAll('.is-active');

        if (activeLists){
            for (const list of activeLists) {
                // Do not remove class for parent
                if (list.contains(listToShow)) {
                    continue;
                }

                // Remove class
                list.classList.remove('is-active');
            }
        }

        // Add active class
        if (listToShow) {
            listToShow.classList.add('is-active');
        }
    }

    initSlider() {
        // Set config values
        const maxValue = this.filter.range_max / 100;

        // Init slider
        const slider = noUiSlider.create(this.priceRangeSlider, {
            start: [0, maxValue],
            connect: true,
            step: 1,
            range: {
                min: 0,
                max: maxValue
            }
        });

        // Listen for changes
        slider.on('slide.one', () => {
            // Get data- and determine lower/upper values
            const data = slider.get();
            const lowerValue = parseInt(Object.values(data)[0], 10);
            const lower = lowerValue.toString();
            const upperValue = parseInt(Object.values(data)[1], 10);
            const upper = upperValue.toString();

            this.inputMin.value = lower;
            this.inputMax.value = upper;
        });
    }
}
